module.exports = __webpack_public_path__ + "img/sail_code.ca3eb331.webp";